import { PERMISSIONS_KEY } from '@/config/constants'

const allPermission = '*:*:*'

const emptyArray = () => []
const emptyObject = () => ({})
const emptyNullable = () => null
const emptyPage = (recordsKey = 'records') => (config = {}) => ({
  [recordsKey]: [],
  total: 0,
  current: Number(config.params?.current) || 1,
  size: Number(config.params?.size) || 10,
  pages: 0
})
const emptyWorkspaces = (config = {}) => ({
  workspaces: [],
  total: 0,
  current: Number(config.params?.current) || 1,
  size: Number(config.params?.size) || 10,
  pages: 0
})
const emptyDailyStats = () => ({
  totalCount: 0,
  failedCount: 0,
  nonFailedCount: 0
})

const rules = [
  { methods: ['post'], pattern: /^\/api\/scripts\/\d+\/opened$/, permission: 'script:view' },
  { methods: ['post'], pattern: /^\/api\/scripts\/[^/]+\/feishu-editor\/jobs\/[^/]+\/retry$/, permission: 'volc_asset:upload' },
  { methods: ['get'], pattern: /^\/api\/scripts\/[^/]+\/feishu-editor\/jobs\/[^/]+\/receipt$/, permission: 'volc_asset:upload' },
  { methods: ['get'], pattern: /^\/api\/scripts\/[^/]+\/feishu-editor(?:\/[^/]+)?$/, permission: 'volc_asset:upload' },
  { methods: ['post'], pattern: /^\/api\/scripts\/[^/]+\/feishu-editor\/[^/]+\/submit$/, permission: 'volc_asset:upload' },
  { methods: ['get'], pattern: new RegExp('^/api/scripts/[^/]+/image-cover-candidates$'), permission: 'image:view' },
  { methods: ['put'], pattern: new RegExp('^/api/scripts/[^/]+/image-cover$'), permission: 'image:view' },
  { methods: ['get'], pattern: /^\/api\/scripts\/mine$/, permission: 'script:view', emptyResponse: emptyArray },
  { methods: ['get'], pattern: /^\/api\/scripts(?:\/.*)?$/, permission: 'admin:script:page', emptyResponse: emptyArray },
  { methods: ['post'], pattern: /^\/api\/scripts$/, permission: 'script:create' },
  { methods: ['delete'], pattern: /^\/api\/scripts\/[^/]+$/, permission: 'script:delete' },

  { methods: ['get'], pattern: /^\/api\/video\/records\/statistics\/my-daily$/, permission: 'video:statistics:view', emptyResponse: emptyDailyStats },
  { methods: ['get'], pattern: /^\/api\/video\/image\/records$/, permission: 'image:view', emptyResponse: emptyPage() },
  { methods: ['post'], pattern: /^\/api\/video\/image\/(?:generate|retry)$/, permission: 'image:generate' },
  { methods: ['post'], pattern: /^\/api\/video\/image\/local-upload$/, permission: 'image:generate' },
  { methods: ['get'], pattern: /^\/api\/video\/progress(?:\/local)?$/, permission: ['video:view', 'image:view'], emptyResponse: emptyObject },
  { methods: ['post'], pattern: /^\/api\/video\/progress(?:\/local)?$/, permission: ['video:view', 'image:view'] },
  { methods: ['get'], pattern: /^\/api\/video\/records$/, permission: 'video:view', emptyResponse: emptyPage() },
  { methods: ['get'], pattern: /^\/api\/video\/records\/[^/]+$/, permission: 'video:view', emptyResponse: emptyNullable },
  { methods: ['post'], pattern: /^\/api\/video\/generate$/, permission: 'video:generate' },
  { methods: ['post'], pattern: /^\/api\/video\/remix$/, permission: 'video:generate' },
  { methods: ['put', 'delete'], pattern: /^\/api\/video\/records\/[^/]+\/remark$/, permission: 'video:update_remark' },
  { methods: ['delete'], pattern: /^\/api\/video\/records\/[^/]+$/, permission: ['video:delete', 'image:delete'] },

  { methods: ['post'], pattern: /^\/api\/canvas\/canvases\/[^/]+\/generation-tasks$/, permission: 'canvas:generate' },
  { methods: ['get', 'post', 'put', 'patch', 'delete'], pattern: /^\/api\/canvas(?:\/.*)?$/, permission: 'canvas:page' },

  { methods: ['get'], pattern: /^\/api\/workspace\/my$/, permission: 'workspace:view', emptyResponse: emptyWorkspaces },
  { methods: ['get'], pattern: /^\/api\/workspace(?:\/.*)?$/, permission: 'workspace:view', emptyResponse: emptyArray },
  { methods: ['post'], pattern: /^\/api\/workspace$/, permission: 'workspace:create' },
  { methods: ['put', 'patch'], pattern: /^\/api\/workspace(?:\/.*)?$/, permission: 'workspace:edit' },
  { methods: ['delete'], pattern: /^\/api\/workspace(?:\/.*)?$/, permission: 'workspace:delete' },

  { methods: ['get'], pattern: /^\/api\/character\/schedule\/list$/, permission: 'character:view', emptyResponse: emptyPage() },
  { methods: ['get'], pattern: /^\/api\/character(?:\/.*)?$/, permission: 'character:view', emptyResponse: emptyNullable },
  { methods: ['post'], pattern: /^\/api\/character(?:\/.*)?$/, permission: 'character:create' },
  { methods: ['put', 'patch'], pattern: /^\/api\/character(?:\/.*)?$/, permission: 'character:edit' },
  { methods: ['delete'], pattern: /^\/api\/character(?:\/.*)?$/, permission: 'character:delete' },

  { methods: ['post'], pattern: /^\/api\/volc\/asset\/group\/create$/, permission: 'volc_asset:group:create' },
  { methods: ['put', 'patch'], pattern: /^\/api\/volc\/asset\/group\/[^/]+$/, permission: 'volc_asset:group:edit' },
  { methods: ['delete'], pattern: /^\/api\/volc\/asset\/group\/[^/]+$/, permission: 'volc_asset:group:delete' },
  { methods: ['post'], pattern: /^\/api\/volc\/asset\/upload(?:\/.*)?$/, permission: 'volc_asset:upload' },
  { methods: ['put', 'patch'], pattern: /^\/api\/volc\/asset\/[^/]+$/, permission: 'volc_asset:edit' },
  { methods: ['delete'], pattern: /^\/api\/volc\/asset\/[^/]+$/, permission: 'volc_asset:delete' },
  { methods: ['get'], pattern: /^\/api\/volc\/asset(?:\/.*)?$/, permission: 'volc_asset:view', emptyResponse: emptyArray },

  { methods: ['get'], pattern: /^\/api\/inspiration\/materials(?:\/.*)?$/, permission: 'inspiration:view', emptyResponse: emptyPage() },
  { methods: ['post'], pattern: /^\/api\/inspiration\/materials$/, permission: 'inspiration:create' },
  { methods: ['put', 'patch'], pattern: /^\/api\/inspiration\/materials\/[^/]+(?:\/.*)?$/, permission: 'inspiration:edit' },
  { methods: ['delete'], pattern: /^\/api\/inspiration\/materials\/[^/]+$/, permission: 'inspiration:delete' },
  { methods: ['get'], pattern: /^\/api\/inspiration\/tags\/tree$/, permission: 'inspiration:view', emptyResponse: emptyArray },
  { methods: ['post'], pattern: /^\/api\/inspiration\/tags$/, permission: ['inspiration:create', 'inspiration:tag:manage'] },
  { methods: ['put', 'patch', 'delete'], pattern: /^\/api\/inspiration\/tags\/[^/]+(?:\/.*)?$/, permission: 'inspiration:tag:manage' },

  { methods: ['post', 'patch'], pattern: /^\/api\/video\/subtitle-removal\/tasks\/[^/]+\/(?:resume-query|timeout-fail)$/, permission: 'subtitle_removal:submit' },
  { methods: ['post', 'put', 'patch'], pattern: /^\/api\/video\/subtitle-removal\/tasks\/[^/]+\/result-url$/, permission: 'subtitle_removal:update_result' },
  { methods: ['get', 'post'], pattern: /^\/api\/video\/qiniu\/subtitle-result-upload-signature$/, permission: 'subtitle_removal:update_result' },
  { methods: ['delete'], pattern: /^\/api\/video\/subtitle-removal\/tasks\/[^/]+$/, permission: 'subtitle_removal:delete' },
  { methods: ['post'], pattern: /^\/api\/video\/subtitle-removal\/tasks$/, permission: 'subtitle_removal:submit' },
  { methods: ['get'], pattern: /^\/api\/video\/subtitle-removal(?:\/.*)?$/, permission: 'subtitle_removal:view', emptyResponse: emptyPage() },

  { methods: ['post'], pattern: /^\/api\/music\/tasks$/, permission: 'music:generate' },
  { methods: ['delete'], pattern: /^\/api\/music\/tasks\/[^/]+$/, permission: 'music:delete' },
  { methods: ['get'], pattern: /^\/api\/music\/tasks$/, permission: 'music:view', emptyResponse: emptyPage() },
  { methods: ['get'], pattern: /^\/api\/music(?:\/.*)?$/, permission: 'music:view', emptyResponse: emptyNullable },

  { methods: ['post'], pattern: /^\/api\/file\/upload\/(?:image|file)$/, permission: 'file:upload' },
  { methods: ['get'], pattern: /^\/api\/file\/upload\/signature$/, permission: 'file:upload' },
  { methods: ['post'], pattern: /^\/api\/file\/upload\/callback$/, permission: 'file:upload' },
  { methods: ['get'], pattern: /^\/api\/script-assets(?:\/.*)?$/, permission: 'script_asset:page', emptyResponse: emptyArray },
  { methods: ['post', 'put', 'patch', 'delete'], pattern: /^\/api\/script-assets(?:\/.*)?$/, permission: 'script_asset:page' },

  { methods: ['get'], pattern: /^\/api\/voice\/generate\/list$/, permission: 'voice:view', emptyResponse: emptyPage() },
  { methods: ['get'], pattern: /^\/api\/voice\/generate\/status$/, permission: 'voice:view', emptyResponse: emptyNullable },
  { methods: ['post'], pattern: /^\/api\/voice\/generate$/, permission: 'voice:generate' },
  { methods: ['post'], pattern: /^\/api\/voice\/generate\/delete$/, permission: 'voice:delete' },

  { methods: ['get'], pattern: /^\/api\/platform\/config\/list$/, permission: 'platform:view', emptyResponse: emptyArray },
  { methods: ['get'], pattern: /^\/api\/auth\/generate-count$/, permission: 'video:page' },
  { methods: ['post'], pattern: /^\/api\/auth\/avatar$/, permission: 'user:upload_avatar' },
  { methods: ['post'], pattern: /^\/api\/auth\/password$/, permission: 'user:modify_password' }
]

function getPermissions() {
  try {
    const permissions = localStorage.getItem(PERMISSIONS_KEY)
    return permissions ? JSON.parse(permissions) : []
  } catch (error) {
    return []
  }
}

function normalizePath(url = '') {
  if (!url) return ''
  const withoutHash = String(url).split('#')[0]
  const withoutQuery = withoutHash.split('?')[0]

  try {
    return new URL(withoutQuery, window.location.origin).pathname.replace(/\/+$/, '') || '/'
  } catch (error) {
    const path = withoutQuery.replace(/^[a-z][a-z\d+\-.]*:\/\/[^/]+/i, '')
    const normalized = path.startsWith('/') ? path : `/${path}`
    return normalized.replace(/\/+$/, '') || '/'
  }
}

function normalizeMethod(method = 'get') {
  return String(method || 'get').toLowerCase()
}

function hasPermission(permission) {
  if (!permission) return true
  const permissions = getPermissions()
  if (!Array.isArray(permissions)) return false
  if (permissions.includes(allPermission)) return true
  if (Array.isArray(permission)) {
    return permission.some(item => permissions.includes(item))
  }
  return permissions.includes(permission)
}

export function getBlockedPermission(config = {}) {
  const rule = getBlockedPermissionRule(config)
  return rule?.permission || ''
}

export function getBlockedPermissionRule(config = {}) {
  const path = normalizePath(config.url)
  const method = normalizeMethod(config.method)
  const rule = rules.find(item =>
    item.methods.includes(method) && item.pattern.test(path)
  )

  if (!rule || hasPermission(rule.permission)) return null
  return rule
}

export function getEmptyPermissionResponse(rule, config = {}) {
  if (!rule?.emptyResponse) return null
  const data = typeof rule.emptyResponse === 'function'
    ? rule.emptyResponse(config)
    : rule.emptyResponse
  return {
    code: 200,
    message: 'OK',
    data
  }
}

export function createPermissionBlockedError(permission) {
  const error = new Error('无权限')
  error.isPermissionBlocked = true
  error.permission = permission
  return error
}
